import request from "@/utils/request";

export default function adminGetNewsType() {
    return request({
        url: `/newsType/agencyGetNewsType`,
        method: 'get',
    })
}
